import { Injectable } from "@angular/core";
import { LogLevels } from "./log_levels";
import { AppConfigService } from "../app-config.service";
import { CargoModel, ClientInfoModel } from "../model";


export class Logger {
    private static _instance: Logger;

    public logLevel: LogLevels = LogLevels.Info;
    private serviceURL: string = "https://logger.anytrack.kz/log"
    private user: ClientInfoModel | null = null;
    private cargoId: number = 0;

    public static get Instance() {
        return this._instance || (this._instance = new Logger());
    }

    public set API_URL(url: string) {
        this.serviceURL = url;
    }

    public set LogLevel(logLevel: LogLevels) {
        this.logLevel = logLevel;
    }

    public set User(user: ClientInfoModel | null) {
        this.user = user;
    }

    public set CargoId(cargoId: number) {
        this.cargoId = cargoId;
    }

    private _serverLog(level: string, message: string, data: any, error: any = null) {
        let jsonData: any = {
            message: message,
            data: data,
            userAgent: navigator.userAgent,
            location: location.href,
            cargo_id: this.cargoId,
            user: {id: this?.user?.id, login: this?.user?.login}
        }

        if(error) {
            jsonData.error = error;
        }
       
        fetch(`${this.serviceURL}/${level}`, {
            method: "POST",
            mode: "no-cors", // no-cors, *cors, same-origin
            cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
            
            body: JSON.stringify(jsonData)
        });
    }

    public log(message: string, data: any) {
        if (this.logLevel <= LogLevels.Debug) {
            console.log(message, data);
            this._serverLog("debug", message, data);
        }
    }

    public info(message: string, data: any) {
        if (this.logLevel <= LogLevels.Info) {
            console.log(message, data);
            this._serverLog("info", message, data);
        }
    }

    public warning(message: string, data: any) {
        if (this.logLevel <= LogLevels.Warn) {
            console.warn(message, data);
            this._serverLog("warning", message, data);
        }
    }

    public error(message: string, data: any, params: any = null) {
        if (this.logLevel <= LogLevels.Error) {
            console.error(message, data, params);
            this._serverLog("error", message, data, {params: params});
        }
    }


}